import React, {Fragment, Component} from 'react';

export default class SuccessPopup extends Component{

    constructor(props){
        super(props);

        let useButton = props.useButton;
        let style = props.style;
        //let appearAboveModal= props.appearAboveModal;
        if (!props.useButton) useButton = false;
        if (!props.style) style="success";
        //if (!appearAboveModal) appearAboveModal=false;
        this.state={
          useButton,
          style,
        }
    }

    componentWillReceiveProps(newProps){
        //console.log("popup new props");
        //console.log(newProps);
        if (newProps.trigger === true){
            console.log("Popup triggered")
            setTimeout(function() {
              document.getElementById(newProps.popupId + "-trigger").click();
            }, 0);;
           

            if(!this.state.useButton){
                setTimeout(function() {
                    newProps.callback();
                }, 0);
            }
           
        }
    }

render(){
  return(
    <Fragment>
      <button id={this.props.popupId + "-trigger"} data-toggle="popup" data-target={"#"+this.props.popupId} style={{display: "none"}}>Popup Trigger Button</button>
      <div id={this.props.popupId} className="popup col-12 col-md-3 p-0 pl-0 pr-0" data-position="top-center" data-animation="slide-down" data-autohide={this.state.useButton ? undefined : 5000} style={{zIndex: 5000}}>
          <button type="button" className="close" data-dismiss="popup" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <div className={"media alert-"+this.state.style+" p-4"}>
              <div className="media-body">
                  <label className="fs2m fw-800 text-capitalize"><i className={"ti ti-check text-"+this.state.style+" mr-2"} aria-hidden="true"></i>{this.props.title}</label>
                  <label className="text-center mb-0 ml-5">{this.props.message}</label>
                  {this.state.useButton ? 
                      <p className="text-center mt-5"><button className={"btn btn-"+this.state.style+" m-0"} data-dismiss="popup" aria-label="Close" onClick={this.props.callback}>Dismiss</button></p>
                  : null}
              </div>
          </div>
      </div>
    </Fragment>)
  }

}